/* eslint-disable max-len */
const desktop = theme => {
  const {toVW} = theme;

  const MODAL_WIDTH = 500;

  return {
    sheetContainer: {
      width: [MODAL_WIDTH, '!important'],
      left: [`calc(50% - ${MODAL_WIDTH / 2}px)`, '!important'],
    },
  };
};

const mobile = theme => {
  const {toVW} = theme;

  return {
    sheetContainer: {
      // background: theme.backgroundColor,
      // borderRadius: '15px 15px 0 0',
    },
    sheetHeader: {
      background: theme.backgroundColor,
      borderRadius: '15px 15px 0 0',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: [5, 0],
      '& > h3': {
        fontSize: 20,
        fontWeight: '700',
        margin: [20, 0],
      },
    },
    sheetContent: {
      background: theme.backgroundColor,
      paddingBottom: 'var(--merchant-bottom-inset, 0px)',
    },
    backIcon: {
      position: 'absolute',
      left: 0,
      transform: 'rotate(180deg)',
    },
    closeIcon: {
      position: 'absolute',
      right: 0,
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
